import React, {useEffect, useState} from 'react';
import {FormattedMessage} from 'react-intl';

import {maxServiceCards} from 'utils/constants/constants';

import Loader from 'components/loader';
import {ICmService, ICmServicePage} from '../../redux/cm-service/interfaces';
import {DmResourceCard} from '../dm-resource-card';

import './styles.scss';
import cn from 'classnames';

type Props = {
  cards: ICmService[];
  showLoader?: boolean;
  onLoadMore?: (count: number) => void;
  onClickCard: (srvId: number) => void;
  page?: ICmServicePage;
  styleClass?: string;
}

export const DmCardSection = ({
  showLoader = false,
  cards,
  onLoadMore,
  onClickCard,
  page,
  styleClass
}: Props): JSX.Element => {
  const [countCards, setCountCards] = useState(onLoadMore ? maxServiceCards : cards.length);
  const [totalElements, setTotalElements] = useState(0);
  const [cardsList, setCardsList] = useState<ICmService[]>(cards);

  useEffect(() => {
    if (page) {
      setTotalElements(page.totalElements);
    }
  }, [page]);

  useEffect(() => {
    setCardsList(cards);
    setCountCards(cards.length);
  }, [cards]);

  function handleLoadMore() {
    if (onLoadMore) {
      onLoadMore(countCards / maxServiceCards);
    }
    setCountCards(countCards + maxServiceCards);
  }

  function handleClickCard(id: number) {
    return () => {
      onClickCard(id);
    };
  }

  const showing = Math.min(countCards, cardsList.length);
  const showLoadMoreButton = totalElements > 0 && totalElements > maxServiceCards && totalElements > countCards && onLoadMore;

  return (
    <section className={cn('dm-card-section', styleClass)}>
      {totalElements > 0 && (
        <div className="dm-card-section__header">
          <span>
            <FormattedMessage
              id="gritx.cmresource.sectionCards.total"
              defaultMessage="{showing} of {total} resources"
              values={{
                showing: <b>{showing}</b>,
                total: <b>{totalElements}</b>
              }}
            />
          </span>
        </div>
      )}
      <ul className="dm-card-section__list">
        {cardsList.map((card, i) => i < countCards
          ? (
            <li key={card.srvId} className="dm-card-section__item">
              <DmResourceCard
                card={card}
                onClick={handleClickCard(card.srvId)}
              />
            </li>
          )
          : null
        )}
      </ul>
      <div className="dm-card-section__footer">
        {showLoader
          ? <Loader />
          : showLoadMoreButton && (
            <button className="dm-card-section__button-load" onClick={handleLoadMore}>
              <FormattedMessage id="gritx.cmresource.sectionCards.load" defaultMessage="Load more cards" />
            </button>
          )
        }
      </div>
    </section>
  );
};
